import { create } from 'zustand';

/** The conversation the Test screen's chat opened last, which the Data tab reads from. */
export const useTestConversation = create<{ contextId: string | null }>(() => ({
  contextId: null,
}));
